import React, { useContext } from 'react';

import {
  ExperienceEntityId,
  NavigationItem,
  ExperienceEntityTree,
  ExperienceEntity,
  ExperienceVenueEntity,
} from './types';

export type ExperienceModuleContextProps = {
  experienceEntity: ExperienceEntity; // Entity Selected in in the sidebar switcher
  experienceEntityTree: ExperienceEntityTree;
  parentEntityId?: ExperienceEntityId; // only use for brand
  country: Country;
  currency: Currency;
  timezone: string;
  name: string;
  address: string;
  city: string;
  image: string;
  initials: string;
  isWoltPlus: boolean;
  activeNavigation?: NavigationItem;
  setActiveNavigation: (navigation: NavigationItem) => void;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (value: boolean) => void;
  selectedExperienceEntity: ExperienceEntity; // Entity selected in the page
  setSelectedExperienceEntity: (entity: ExperienceEntity) => void;
  selectedExperienceVenueEntity: ExperienceVenueEntity | null; // Venue Entity selected in the page
  setSelectedExperienceVenueEntity: (entity: ExperienceVenueEntity | null) => void;
};

export const ExperienceModuleContext = React.createContext(undefined as unknown as ExperienceModuleContextProps);

export const useExperienceModuleContext = () => {
  const {
    currency,
    experienceEntity,
    experienceEntityTree,
    country,
    timezone,
    name,
    address,
    city,
    image,
    initials,
    isWoltPlus,
    activeNavigation,
    setActiveNavigation,
    isSidebarOpen,
    setIsSidebarOpen,
    selectedExperienceEntity,
    setSelectedExperienceEntity,
    selectedExperienceVenueEntity,
    setSelectedExperienceVenueEntity,
  } = useContext(ExperienceModuleContext);

  return {
    currency,
    experienceEntity,
    experienceEntityTree,
    country,
    timezone,
    name,
    address,
    city,
    image,
    initials,
    isWoltPlus,
    activeNavigation,
    setActiveNavigation,
    isSidebarOpen,
    setIsSidebarOpen,
    selectedExperienceEntity,
    setSelectedExperienceEntity,
    selectedExperienceVenueEntity,
    setSelectedExperienceVenueEntity,
  };
};

export const ExperienceModuleContextProvider = ExperienceModuleContext.Provider;
